import { ACCESS_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from './api';

export const isAuthenticated = (): boolean => {
  return Boolean(localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY));
};

export const storeTokens = (access: string, refresh: string): void => {
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, access);
  localStorage.setItem(REFRESH_TOKEN_STORAGE_KEY, refresh);
};

export const clearTokens = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
  localStorage.removeItem(REFRESH_TOKEN_STORAGE_KEY);
};

export const getRefreshToken = (): string => {
  return localStorage.getItem(REFRESH_TOKEN_STORAGE_KEY) || '';
};
